import { useEffect, useState } from "react";
import DashboardLayout from "../../components/DashboardLayout";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

const OfficerDashboard = () => {
  const [officer, setOfficer] = useState(null);

  useEffect(() => {
    const fetchOfficer = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const decoded = jwtDecode(token);
        const officer_id = decoded.officer_id;

        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/officers/${officer_id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setOfficer(res.data);
      } catch (err) {
        console.error("Failed to fetch officer data", err);
      }
    };

    fetchOfficer();
  }, []);

  

  
  if (!officer) return <DashboardLayout role="officer">Loading...</DashboardLayout>;

  return (
    <DashboardLayout role="officer">
      <div className="officer-profile" style={{ display: "flex", alignItems: "center", gap: "1rem", padding: "1rem" }}>
        <img
          src={officer.photo ? `${process.env.REACT_APP_API_URL}/uploads/${officer.photo}` : "/default-profile.png"}
          alt="Profile"
          style={{ width: "150px", height: "200px", objectFit: "cover" }}
        />
        <div>
          <h2>{officer.full_name}</h2>
          <p><strong>Position:</strong> {officer.position}</p>
          <p><strong>Department:</strong> {officer.division}</p>
          <p><strong>Email:</strong> {officer.email || "-"}</p>
          <p><strong>Phone:</strong> {officer.whatsapp_number || "-"}</p>
          <p><strong>Akun Payroll:</strong> {officer.payroll_account || "-"}</p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default OfficerDashboard;
